export enum LINE_STEP {
  ABOUT = 'stepperAbout',
  JOURNEYPATTERN = 'stepperJourneyPattern',
  SERVICEJOURNEY = 'stepperServiceJourney',
}

export const FIXED_LINE_STEPS: LINE_STEP[] = [
  LINE_STEP.ABOUT,
  LINE_STEP.JOURNEYPATTERN,
  LINE_STEP.SERVICEJOURNEY,
];
